import { gql } from '@apollo/client';
import { GqlSeason, GqlSeasonFragment } from '../fragments/season';

export interface Input {
  country: string;
  id: number;
  name: string;
  sport: string;
  zipCode: string;
  timezone: string;
}

export interface Data {
  updateSeason: GqlSeason;
}

export const MUTATION = gql`
  mutation UpdateSeason(
    $country: String!
    $name: String!
    $id: Int!
    $startDate: String
    $endDate: String
    $sportId: Int
    $areaOfOperation: Int
    $timezone: String!
    $zipCode: String!
  ) {
    updateSeason(
      country: $country
      name: $name
      id: $id
      timezone: $timezone
      zipCode: $zipCode
      startDate: $startDate
      endDate: $endDate
      sportId: $sportId
      areaOfOperation: $areaOfOperation
    ) {
      ...SeasonFields
    }
  }
  ${GqlSeasonFragment}
`;
